import { RouteConfig } from 'react-router-config';
import { PriceCalculateRouter } from '../../pages/price-calculate';

export const PRICE_ROUTE: RouteConfig[] = [
  {
    path: '/price-calculator',
    component: PriceCalculateRouter,
    // routes: [
    // ],
  },
];
